import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { combineLatest, tap } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { CountryRegion } from '@core/locations-types';

import { RegionActions, RegionSelectors } from './regions.store';

@Injectable({ providedIn: 'root' })
export class RegionsStoreService {
  private readonly store = inject(Store);

  private _countryHasRegions = new Map<string, boolean>();

  public getOrLoadCountryRegions(countryCode: string): Observable<CountryRegion[]> {
    combineLatest([
      this.store.select(RegionSelectors.isPending(countryCode)),
      this.store.select(RegionSelectors.isLoaded(countryCode)),
      this.store.select(RegionSelectors.error(countryCode)),
    ])
      .pipe(take(1))
      .subscribe(([loading, loaded, error]) => {
        if ((loaded || loading) && !error) return;

        this.store.dispatch(RegionActions.fetchOne({ payload: { id: countryCode } }));
      });

    return this.store.select(RegionSelectors.byCountyCode(countryCode)).pipe(
      filterBoolean,
      tap(({ regions }) => {
        this._countryHasRegions.set(countryCode, regions.length > 0);
      }),
      map(({ regions }) => regions),
    );
  }
}
